var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-wrapper",on:{"mouseenter":function($event){_vm.show = true},"mouseleave":function($event){_vm.show = false}}},[_vm._t("icon"),(_vm.show)?_c('div',{staticClass:"tooltip-box"},[_vm._t("default")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }